export class Controller {

    /** @ngInject */
    constructor($stateParams, $window, $state, $rootScope, Alert, ConfirmModal, LicenseManagementService, LicenseTierDetails) {
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.Alert = Alert;
        this.ConfirmModal = ConfirmModal;
        this.LicenseManagementService = LicenseManagementService;
        this.LicenseTierDetails = LicenseTierDetails;
    }

    $onInit() {
        this.emailPattern = this.$rootScope.emailPattern;
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.licenseInfo.autoRenewalEnabled = true;
        this.currentPlan = this.licenseDetails.companyLicensePlan;
        this.featureUsages = [];
        if(this.licenseDetails.featureUsages.length > 0) {
            this.featureUsages = JSON.parse(this.licenseDetails.featureUsages);
            if(!this.licenseInfo.portalActionsRestricted) {
                this.featureUsages.forEach((usage) => {
                    if(usage.feature === 'Number of user licenses') {
                        usage.sref = 'company.user-directories.saaspass-users';
                    } else if(usage.feature === 'Number of Active Directories') {
                        usage.sref = 'company.directory-integration';
                    } else if(usage.feature === 'Number of LDAP Directories') {
                        usage.sref = 'company.directory-integration';
                    } else if(usage.feature === 'Number of admins') {
                        usage.sref = 'company.administrators';
                    } else if(usage.feature === 'Number of Sms users') {
                        usage.sref = 'company.user-directories.saaspass-users.sms-users';
                    } else if(usage.feature === 'Number of Custom apps') {
                        usage.sref = 'company.custom-app-integration';
                    } else if(usage.feature === 'Number of prebuilt SAML apps') {
                        usage.sref = 'company.applications';
                    } else if(usage.feature === 'Number of Custom SAML apps') {
                        usage.sref = 'company.applications';
                    } else if(usage.feature === 'Number of VPN apps') {
                        usage.sref = 'company.applications';
                    } else if(usage.feature === 'Number of Computer login apps') {
                        usage.sref = 'company.computer-protection';
                    } else if(usage.feature === 'Number of EPM apps') {
                        usage.sref = 'company.applications';
                    } else if(usage.feature === 'Number of Sharing Center apps') {
                        usage.sref = 'company.applications';
                    }
                })
            }
        }
    }

    autoRenewalEnabled() {
        return !this.currentPlan.cancelAtSubscriptionEnd;
    }

    cancelAutoRenewal() {
        this.ConfirmModal({
            messageKey: 'Subscription will be cancelled at the end of the subscription period. Do you want to continue?',
            titleKey: 'sp-confirm.title'
        })
        .then(() => {
                this.LicenseManagementService.cancelAutoRenewal(this.$stateParams.companyId)
                    .then(()=> {
                        this.Alert('success', 'global.messages.operation-successful');
                        this.currentPlan.cancelAtSubscriptionEnd = true;
                    })
            }
        )
    }

    viewTierDetails() {
        this.LicenseTierDetails(this.licenseTiers);
    }

    cancelWaitingActivity() {
        this.LicenseManagementService.cancelWaitingActivity(this.$stateParams.companyId)
            .then(()=> {
                this.Alert('success', 'global.messages.operation-successful');
                this.$state.reload('company.license-management');
            })      
    }

    setPaymentMethod() {
        this.LicenseManagementService.setPaymentMethod(this.$stateParams.companyId)
            .then((url)=> {
                this.$window.open(url, '_blank');
            }) 
    }
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/current-plan.controller.js